import { TARGETING_ATTRIBUTE, AGE_BASIS } from '../constants'

export const validateTargeting = (schedule, scheduleIndex) => {
  const errors = {}
  ;(schedule?.targeting || []).forEach((row, index) => {
    const prefix = `schedules.${scheduleIndex}.targeting.${index}`
    if (!row.attribute) {
      errors[`${prefix}.attribute`] = 'Select a targeting attribute.'
    }
    if (row.value === '' || row.value == null) {
      errors[`${prefix}.value`] = 'Enter a targeting value.'
    }
    if (row.attribute === TARGETING_ATTRIBUTE.age && !Object.values(AGE_BASIS).includes(row.ageBasis)) {
      errors[`${prefix}.ageBasis`] = 'Select an age basis.'
    }
  })
  return errors
}
